<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{ this.$route.name }}
    </div>
    <div class="box p-2">
      <!-- <hr class="mb-0"> -->
      <b-tabs content-class="mt-3 border-0">
        <b-tab title="Pending" id="info_1_tab" active class="p-0">
          <div class="pt-0">
            <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered"
              :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
              <template v-slot:cell(thumbnail)="data">
                <b-btn @click="showModal('blog' + data.item.id)" size="sm" class="btn-table green"><i
                    class="fas fa-eye mr-5"></i>View</b-btn>
                <b-modal modal-class="modal-custom-image" hide-footer :ref="'blog' + data.item.id" centered
                  title="Blog">
                  <img class="w-100 img-fix" :src="parseImg(data.item.thumbnail)">
                </b-modal>
              </template>
              <template v-slot:cell(status)="data">
                <template v-if="data.item.status">
                  <b-badge variant="warning">{{ data.item.status }}</b-badge>
                </template>
              </template>
              <template v-slot:cell(actions)="data">
                <template v-if="data.item.approver_id == approverId || data.item.can_approve || getRoleId == 1">
                  <b-button v-if="getRoleId != '33'" size="sm" @click="onApproved(data.item)"
                    class="btn-table primary mr-1">
                    <i class="far fa-edit"></i> Approve
                  </b-button>
                  <b-button v-if="getRoleId != '33'" size="sm" v-on:click="onReject(data.item)"
                    class="btn-table danger">
                    <i class="fas fa-times"></i> Reject
                  </b-button>
                </template>
              </template>
            </b-table>
            <app-pagination class="pagination-custom mt-20" :current-page="currentPage" :total-pages="totalPage"
              @page-changed="pageOneChanged" prev-text="Prev" next-text="Next" />
          </div>
        </b-tab>
        <b-tab title="Approved" id="info_1_tab" class="p-0">
          <div class="pt-0">
            <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered"
              :small="small" :fixed="fixed" responsive="sm" :items="itemsApproved" :fields="fieldsApproved"
              :current-page="currentPage">
              <template v-slot:cell(thumbnail)="data">
                <b-btn @click="showModal('blog' + data.item.id)" size="sm" class="btn-table green"><i
                    class="fas fa-eye mr-5"></i>View</b-btn>
                <b-modal modal-class="modal-custom-image" hide-footer :ref="'blog' + data.item.id" centered
                  title="Blog">
                  <img class="w-100 img-fix" :src="parseImg(data.item.thumbnail)">
                </b-modal>
              </template>
              <template v-slot:cell(status)="data">
                <template v-if="data.item.status">
                  <b-badge variant="success" v-if="data.item.description == 'AUTO APPROVED BY SYSTEM'">APPROVED BY
                    SYSTEM</b-badge>
                  <b-badge variant="success" v-else>{{ data.item.status }}</b-badge>
                </template>
              </template>
              <template v-slot:cell(actions)="data">
                <b-button v-if="getRoleId != '33'" size="sm" class="btn-table primary mr-1">
                  <i class="far fa-edit"></i> Approve
                </b-button>
                <b-button v-if="getRoleId != '33'" size="sm" class="btn-table danger">
                  <i class="fas fa-times"></i> Reject
                </b-button>
              </template>
            </b-table>
            <app-pagination class="pagination-custom mt-20" :current-page="currentPageApproved"
              :total-pages="totalPageApproved" @page-changed="pageTwoChanged" prev-text="Prev" next-text="Next" />
          </div>
        </b-tab>
      </b-tabs>
    </div>
    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="40" alt="">
        <br>
        <div class="title-loading color-white">Please wait...</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'

export default {
  name: 'blog',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      loadingActive: false,
      fields: [
        {
          key: 'refid',
          label: 'Document',
          sortable: false
        },
        {
          key: 'notes',
          label: 'Request',
          sortable: false,
        },
        {
          key: 'description',
          label: 'Description',
          sortable: false
        },
        {
          key: 'status',
          label: 'Status',
          sortable: false
        },
        {
          key: 'requested_info.member_name',
          label: 'Request By',
          sortable: false,
          formatter: (value, key, item) => {
            return item.requested_by == Auth.Session.get().paradigm_user_id ? 'You' : item.requested_by == 1 ? 'Admin' : item.requested_info.member_name
          }
        },
        {
          key: 'requested_at',
          label: 'Request Date',
          sortable: false
        },
        {
          key: 'actions',
          label: 'Actions',
          sortable: false
        }
      ],
      fieldsApproved: [
        {
          key: 'refid',
          label: 'Document',
          sortable: false
        },
        {
          key: 'notes',
          label: 'Request',
          sortable: false
        },
        {
          key: 'description',
          label: 'Description',
          sortable: false,
          formatter: (value, key, item) => {
            return item.description == 'AUTO APPROVED BY SYSTEM' ? '' : item.description ? item.description : '-'
          }
        },
        {
          key: 'status',
          label: 'Status',
          sortable: false
        },
        {
          key: 'requested_info.member_name',
          label: 'Request By',
          sortable: false,
          formatter: (value, key, item) => {
            return item.requested_by == Auth.Session.get().paradigm_user_id ? 'You' : item.requested_by == 1 ? 'Admin' : item.requested_info.member_name
          }
        },
        {
          key: 'requested_at',
          label: 'Request Date',
          sortable: false
        },
        {
          key: 'approved_at',
          label: 'Approved Date',
          sortable: false
        },

      ],
      items: [],
      itemsApproved: [],
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      totalPageApproved: 0,
      paginationLimitApproved: 10,
      currentPageApproved: 1,
      getRoleId: Auth.Session.get().paradigm_role,
      approverId: Auth.Session.get().paradigm_user_id,
      paradigm_id: Auth.Session.get().paradigm_user_id,
      status: 'PENDING',
    }
  },
  computed: {
    name() {
      return this.$route.name
    }
  },
  methods: {
    onApproved(item) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Approve it!',
        cancelButtonText: 'No, Cancel!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if (result.value) {
          this.loadingActive = true
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token

          const body = {
            refid: item.refid,
            status: 'APPROVED',
            approver_id: Auth.Session.get().paradigm_user_id
          }

          axios.post('crm/v1/approval_request/save_approval', body).then(response => {
            this.loadingActive = false
            this.$swal('APPROVED', 'You successfully Approved!', 'success')
            this.fetchData()
          }).catch(error => {
            this.loadingActive = false
            console.log('error', error.response.data.error)
            this.$swal('Failed', error.response.data.error, 'error')
            return
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    onReject(item) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Reject Now!',
        cancelButtonText: 'No, Cancel!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if (result.value) {
          this.loadingActive = true
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token

          const body = {
            refid: item.refid,
            status: 'REJECTED',
            approver_id: Auth.Session.get().paradigm_user_id
          }

          axios.post('crm/v1/approval_request/save_approval', body).then(response => {
            this.loadingActive = false
            this.$swal('Rejected', 'Request has been rejected!', 'success')
            this.fetchData()
          }).catch(error => {
            this.loadingActive = false
            console.log('error', error)
            this.$swal('Failed', 'You failed Rejected!', 'error')
            return
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    pageOneChanged(pageNum) {
      this.currentPage = pageNum
      // this.fetchData() //
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      this.loadingActive = true
      axios.get('crm/v1/approval_request/my_requests_admin?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&status=' + this.status).then(response => {
        this.loadingActive = false
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
    },
    pageTwoChanged(pageNum) {
      this.currentPageApproved = pageNum

      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      this.loadingActive = true
      axios.get('crm/v1/approval_request/my_requests_admin?page=' + this.currentPageApproved + '&limit=' + this.paginationLimitApproved + '&status=APPROVED').then(response => {
        this.itemsApproved = response.data.data.rows
        this.totalPageApproved = response.data.meta.pageCount
        this.loadingActive = false
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
        this.loadingActive = false
      })
    },
    sortingChanged(event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    enterClicked(searchEvent) {
      this.fetchData()
    },
    getBadge(status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    getRowCount(items) {
      return items.length
    },
    openPage(event) {
      this.$router.push(event)
    },
    editBlog(event) {
      this.$router.push(event)
    },
    showModal(id) {
      this.$refs[id].show()
    },
    deleteBlog(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if (result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.delete('compro/v1/blog/' + (event)).then(response => {
            // this.$router.go()
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    parseImg(value) {
      return Auth.apiUrl + 'compro/v1/img/blog/' + value
    },
    fetchData() {
      this.items = []
      this.itemsApproved = []
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      this.loadingActive = true
      axios.get('crm/v1/approval_request/my_requests_admin?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&status=' + this.status).then(response => {
        this.loadingActive = false
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      axios.get('crm/v1/approval_request/my_requests_admin?page=' + this.currentPageApproved + '&limit=' + this.paginationLimitApproved + '&status=APPROVED').then(response => {
        this.itemsApproved = response.data.data.rows
        this.totalPageApproved = response.data.meta.pageCount
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created() {
    this.fetchData()
  }
}
</script>

<style></style>
